module.exports = __webpack_public_path__ + "img/twitter.1e16037b.svg";